import {Button} from '@hm/fundamental'
import {mdiRestore} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {COLOR_PICKER_WIDGET_NAMESPACE} from '../consts'
import {useCanEditColors} from '../hooks'

interface ResetLocalColorCellProps {
  globalColor: string
  localColor: string | undefined
  onColorReset: () => void
  isDisabled?: boolean
  dataCy?: string
}

export const ResetLocalColorCell: React.FC<ResetLocalColorCellProps> = ({
  globalColor,
  localColor,
  onColorReset,
  isDisabled = false,
  dataCy = 'reset-local-color'
}) => {
  const {t} = useTranslation(COLOR_PICKER_WIDGET_NAMESPACE)
  const canEditColors = useCanEditColors()

  const hasLocalOverride = localColor !== undefined && localColor !== globalColor

  if (!hasLocalOverride || !canEditColors) {
    return null
  }

  return (
    <Button
      variant="tertiary"
      icon={mdiRestore}
      onClick={onColorReset}
      size="small"
      square
      disabled={isDisabled}
      data-cy={`${dataCy}-btn`}
      title={t('localColors.resetToGlobal')}
    />
  )
}
